import React, { useState } from 'react';
import { View } from '@uncinc/react-drupal-core';

const NewsPillarAll = ({ onLoadMore, pager, loading, entities, ...props }) => {
  const [currentPage, setCurrentPageState] = useState(0);

  const setCurrentPage = (page) => {
    setCurrentPageState(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <View page={currentPage} id="news" currentPage={currentPage} setCurrentPage={setCurrentPage} display="all" />
  );
};

export default NewsPillarAll;
